var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBrunoEngineBenefits6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5985 33.9648C37.566 33.9648 40.5726 34.9621 42.9863 37.0766C44.2477 38.1803 45.2113 39.528 45.8581 41.0737C46.4969 42.602 46.8258 44.3175 46.8258 46.1773V66.8436H22.1758V46.1773C22.1758 42.8836 23.2957 40.1762 25.0719 38.1493C26.2686 36.7828 27.7551 35.7343 29.3925 35.0308C31.0245 34.3287 32.8061 33.9648 34.5998 33.9648H34.5985Z",
    fill: "#67C6A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17676 60.8248V20.0312H60.8256V60.8248C60.8256 62.4797 60.1545 63.9837 59.0696 65.074C57.9848 66.1656 56.4875 66.8421 54.838 66.8421H43.1309V48.5652C43.1309 37.3473 25.8701 37.102 25.8701 48.5652V66.8421H14.1644C12.5149 66.8421 11.0176 66.1656 9.93275 65.074C8.84924 63.9837 8.17676 62.4797 8.17676 60.8235V60.8248Z",
    fill: "#E2ECEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6625 2.15625L66.0881 14.2892H2.91406L9.33834 2.15625H59.6625Z",
    fill: "#52C0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4404 25.4396V14.2891H23.971V25.4396C23.971 32.3113 13.4404 32.442 13.4404 25.4396Z",
    fill: "#EC7161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4404 25.4396C13.4404 32.3113 2.91113 32.442 2.91113 25.4396V14.2891H13.4404V25.4396ZM23.971 25.4396V14.2891H34.5002V25.4396C34.5002 32.3221 23.971 32.3221 23.971 25.4396ZM45.0308 25.4396V14.2891H55.56V25.4396C55.56 32.3221 45.0308 32.3221 45.0308 25.4396Z",
    fill: "#FFCB67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5598 25.4396V14.2891H66.0891V25.4396C66.0891 27.0635 65.5163 28.2939 64.6363 29.1591C62.6391 31.1199 59.0112 31.1199 57.0139 29.1591C56.1339 28.2953 55.5612 27.0648 55.5612 25.4396H55.5598ZM34.5 25.4396V14.2891H45.0306V25.4396C45.0306 32.3113 34.5 32.4433 34.5 25.4396Z",
    fill: "#EC7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBrunoEngineBenefits6);
export default __webpack_public_path__ + "static/media/products_bruno_engine_benefits_6.ceb6ffbfcfec5d955de3a44b67fde7fe.svg";
export { ForwardRef as ReactComponent };